"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _LNURL_instances, _LNURL_url, _LNURL_service, _LNURL_validateService;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LNURL = exports.LNURLError = exports.LNURLErrorCode = void 0;
const const_1 = require("./const");
const utils_1 = require("./utils");
const PayServiceTag = "payRequest";
var LNURLErrorCode;
(function (LNURLErrorCode) {
    LNURLErrorCode[LNURLErrorCode["ServiceUnavailable"] = 1] = "ServiceUnavailable";
    LNURLErrorCode[LNURLErrorCode["InvalidLNURL"] = 2] = "InvalidLNURL";
})(LNURLErrorCode = exports.LNURLErrorCode || (exports.LNURLErrorCode = {}));
class LNURLError extends Error {
    constructor(code, msg) {
        super(msg);
        this.code = code;
    }
}
exports.LNURLError = LNURLError;
class LNURL {
    /**
     * Setup LNURL service
     * @param lnurl bech32 lnurl / lightning address / https url
     */
    constructor(lnurl) {
        _LNURL_instances.add(this);
        _LNURL_url.set(this, void 0);
        _LNURL_service.set(this, void 0);
        lnurl = lnurl.toLowerCase().trim();
        if (lnurl.startsWith("lnurl")) {
            const decoded = (0, utils_1.bech32ToText)(lnurl);
            if (!decoded.startsWith("http")) {
                throw new LNURLError(LNURLErrorCode.InvalidLNURL, "Not a url");
            }
            __classPrivateFieldSet(this, _LNURL_url, new URL(decoded), "f");
        }
        else if (lnurl.match(const_1.EmailRegex)) {
            const [handle, domain] = lnurl.split("@");
            __classPrivateFieldSet(this, _LNURL_url, new URL(`https://${domain}/.well-known/lnurlp/${handle}`), "f");
        }
        else if (lnurl.startsWith("https:")) {
            __classPrivateFieldSet(this, _LNURL_url, new URL(lnurl), "f");
        }
        else if (lnurl.startsWith("lnurlp:")) {
            const tmp = new URL(lnurl);
            tmp.protocol = "https:";
            __classPrivateFieldSet(this, _LNURL_url, tmp, "f");
        }
        else {
            throw new LNURLError(LNURLErrorCode.InvalidLNURL, "Could not determine service url");
        }
    }
    /**
     * URL of this payService
     */
    get url() {
        return __classPrivateFieldGet(this, _LNURL_url, "f");
    }
    /**
     * Return the optimal formatted LNURL
     */
    get lnurl() {
        if (this.isLNAddress) {
            return this.getLNAddress();
        }
        return __classPrivateFieldGet(this, _LNURL_url, "f").toString();
    }
    /**
     * Human readable name for this service
     */
    get name() {
        // LN Address formatted URL
        if (this.isLNAddress) {
            return this.getLNAddress();
        }
        // Generic LUD-06 url
        return __classPrivateFieldGet(this, _LNURL_url, "f").hostname;
    }
    /**
     * Is this LNURL a LUD-16 Lightning Address
     */
    get isLNAddress() {
        return __classPrivateFieldGet(this, _LNURL_url, "f").pathname.startsWith("/.well-known/lnurlp/");
    }
    /**
     * Get the LN Address for this LNURL
     */
    getLNAddress() {
        const pathParts = __classPrivateFieldGet(this, _LNURL_url, "f").pathname.split("/");
        const username = pathParts[pathParts.length - 1];
        return `${username}@${__classPrivateFieldGet(this, _LNURL_url, "f").hostname}`;
    }
    /**
     * Create a NIP-57 zap tag from this LNURL
     */
    getZapTag() {
        if (this.isLNAddress) {
            return ["zap", this.getLNAddress(), "lud16"];
        }
        else {
            return ["zap", __classPrivateFieldGet(this, _LNURL_url, "f").toString(), "lud06"];
        }
    }
    async load() {
        const rsp = await fetch(__classPrivateFieldGet(this, _LNURL_url, "f"));
        if (rsp.ok) {
            __classPrivateFieldSet(this, _LNURL_service, await rsp.json(), "f");
            __classPrivateFieldGet(this, _LNURL_instances, "m", _LNURL_validateService).call(this);
        }
    }
    /**
     * Fetch an invoice from the LNURL service
     * @param amount Amount in sats
     * @param comment
     * @param zap
     * @returns
     */
    async getInvoice(amount, comment, zap) {
        const callback = new URL((0, utils_1.unwrap)(__classPrivateFieldGet(this, _LNURL_service, "f")?.callback));
        const query = new Map();
        if (callback.search.length > 0) {
            callback.search
                .slice(1)
                .split("&")
                .forEach(a => {
                const pSplit = a.split("=");
                query.set(pSplit[0], pSplit[1]);
            });
        }
        query.set("amount", Math.floor(amount * 1000).toString());
        if (comment && __classPrivateFieldGet(this, _LNURL_service, "f")?.commentAllowed) {
            query.set("comment", comment);
        }
        if (__classPrivateFieldGet(this, _LNURL_service, "f")?.nostrPubkey && zap) {
            query.set("nostr", JSON.stringify(zap));
        }
        const baseUrl = `${callback.protocol}//${callback.host}${callback.pathname}`;
        const queryJoined = [...query.entries()].map(v => `${v[0]}=${encodeURIComponent(v[1])}`).join("&");
        try {
            const rsp = await fetch(`${baseUrl}?${queryJoined}`);
            if (rsp.ok) {
                const data = await rsp.json();
                console.debug("[LNURL]: ", data);
                if (data.status === "ERROR") {
                    throw new Error(data.reason);
                }
                else {
                    return data;
                }
            }
            else {
                throw new LNURLError(LNURLErrorCode.ServiceUnavailable, `Failed to fetch invoice (${rsp.statusText})`);
            }
        }
        catch (e) {
            throw new LNURLError(LNURLErrorCode.ServiceUnavailable, "Failed to load callback");
        }
    }
    /**
     * Are zaps (NIP-57) supported
     */
    get canZap() {
        return __classPrivateFieldGet(this, _LNURL_service, "f")?.nostrPubkey ? true : false;
    }
    /**
     * Return pubkey of zap service
     */
    get zapperPubkey() {
        return __classPrivateFieldGet(this, _LNURL_service, "f")?.nostrPubkey;
    }
    /**
     * Get the max allowed comment length
     */
    get maxCommentLength() {
        return __classPrivateFieldGet(this, _LNURL_service, "f")?.commentAllowed ?? 0;
    }
    /**
     * Min sendable in milli-sats
     */
    get min() {
        return __classPrivateFieldGet(this, _LNURL_service, "f")?.minSendable ?? 1000; // 1 sat
    }
    /**
     * Max sendable in milli-sats
     */
    get max() {
        return __classPrivateFieldGet(this, _LNURL_service, "f")?.maxSendable ?? 100e9; // 1 BTC in milli-sats
    }
}
exports.LNURL = LNURL;
_LNURL_url = new WeakMap(), _LNURL_service = new WeakMap(), _LNURL_instances = new WeakSet(), _LNURL_validateService = function _LNURL_validateService() {
    if (__classPrivateFieldGet(this, _LNURL_service, "f")?.tag !== PayServiceTag) {
        throw new LNURLError(LNURLErrorCode.InvalidLNURL, "Only LNURLp is supported");
    }
    if (!__classPrivateFieldGet(this, _LNURL_service, "f")?.callback) {
        throw new LNURLError(LNURLErrorCode.InvalidLNURL, "No callback url");
    }
};
//# sourceMappingURL=data:application/json;base64,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